/**
 * Main entry point for the VChart library
 */

// Export everything from components
export * from './components';

// For backwards compatibility with RechartsWrapper
import VChartWrapper from './components/Charts';
export const RechartsWrapper = (props) => {
  // Forward props to VChartWrapper for backward compatibility
  return VChartWrapper(props);
};

// React application mount
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
// import MCPServerService from './services/MCPServerService';

console.log('Initializing Agent Framework application...');

// NOTE: MCP server registration moved to after authentication
// The forceRegisterRunningServers call has been moved to components that need it
// after user authentication is available, since it now requires auth tokens

// Force register the MCP servers on application startup
// (async () => {
//   try {
//     // Use await since the function is now async
//     await MCPServerService.forceRegisterRunningServers();
//     console.log('MCP servers loaded from registry successfully.');
//   } catch (error) {
//     console.error('Error loading MCP servers from registry:', error);
//     console.log('Using default MCP server configuration.');
//   }
// })();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

console.log('Application rendered successfully.'); 